module.exports = __webpack_public_path__ + "static/img/pickup-singlecab-green.232fc01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-singlecab-green.svg
// module id = Wt6E
// module chunks = 74